class MscPollutantType {
  constructor(code, chineseName) {
    this.code = code
    this.chineseName = chineseName
  }
}

export const CODE_NAME = 'MscPollutantType'

// MSC海洋污染
export const MSC_MAR_POLLUTAN_NO = new MscPollutantType('NO', 'No', 'No')
export const MSC_MAR_POLLUTAN_POLLUTANT = new MscPollutantType('POLLUTANT', 'Pollutant', 'Pollutant')
export const MSC_MAR_POLLUTAN_SEVERE = new MscPollutantType('SEVERE', 'Severe', 'Severe')
export const MSC_MAR_POLLUTAN = [MSC_MAR_POLLUTAN_NO, MSC_MAR_POLLUTAN_POLLUTANT, MSC_MAR_POLLUTAN_SEVERE]
